import { render, staticRenderFns, recyclableRender, components } from "./loading5.vue?vue&type=template&id=e476ade6&scoped=true&"
var renderjs
import script from "./loading5.vue?vue&type=script&lang=js&"
export * from "./loading5.vue?vue&type=script&lang=js&"
import style0 from "./loading5.vue?vue&type=style&index=0&id=e476ade6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e476ade6",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/qiun-data-charts/components/qiun-loading/loading5.vue"
export default component.exports